import React from 'react'

import influencerData from '../../data-influencer/cathy'
import PageBuilder from '../PageBuilder'
import PageLayout from './PageLayout'

const Cathy = () => (
    <PageBuilder influencerData={influencerData}>
        <PageLayout />
    </PageBuilder>
)

export default Cathy
